/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ReadingsRouteImport } from './routes/readings'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReadingsIndexRouteImport } from './routes/readings/index'
import { Route as ReadingsStatsRouteImport } from './routes/readings/stats'
import { Route as ReadingsHistoryRouteImport } from './routes/readings/history'
import { Route as ReadingsIdRouteImport } from './routes/readings/$id'
import { Route as InterpretationsNewRouteImport } from './routes/interpretations/new'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadingsRoute = ReadingsRouteImport.update({
  id: '/readings',
  path: '/readings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadingsIndexRoute = ReadingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReadingsRoute,
} as any)
const ReadingsStatsRoute = ReadingsStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => ReadingsRoute,
} as any)
const ReadingsHistoryRoute = ReadingsHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => ReadingsRoute,
} as any)
const ReadingsIdRoute = ReadingsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ReadingsRoute,
} as any)
const InterpretationsNewRoute = InterpretationsNewRouteImport.update({
  id: '/interpretations/new',
  path: '/interpretations/new',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/profile': typeof ProfileRoute
  '/readings': typeof ReadingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/interpretations/new': typeof InterpretationsNewRoute
  '/readings/$id': typeof ReadingsIdRoute
  '/readings/history': typeof ReadingsHistoryRoute
  '/readings/stats': typeof ReadingsStatsRoute
  '/readings/': typeof ReadingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/interpretations/new': typeof InterpretationsNewRoute
  '/readings/$id': typeof ReadingsIdRoute
  '/readings/history': typeof ReadingsHistoryRoute
  '/readings/stats': typeof ReadingsStatsRoute
  '/readings': typeof ReadingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/profile': typeof ProfileRoute
  '/readings': typeof ReadingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/interpretations/new': typeof InterpretationsNewRoute
  '/readings/$id': typeof ReadingsIdRoute
  '/readings/history': typeof ReadingsHistoryRoute
  '/readings/stats': typeof ReadingsStatsRoute
  '/readings/': typeof ReadingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/profile'
    | '/readings'
    | '/signup'
    | '/interpretations/new'
    | '/readings/$id'
    | '/readings/history'
    | '/readings/stats'
    | '/readings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/profile'
    | '/signup'
    | '/interpretations/new'
    | '/readings/$id'
    | '/readings/history'
    | '/readings/stats'
    | '/readings'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/logout'
    | '/profile'
    | '/readings'
    | '/signup'
    | '/interpretations/new'
    | '/readings/$id'
    | '/readings/history'
    | '/readings/stats'
    | '/readings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ProfileRoute: typeof ProfileRoute
  ReadingsRoute: typeof ReadingsRouteWithChildren
  SignupRoute: typeof SignupRoute
  InterpretationsNewRoute: typeof InterpretationsNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/readings': {
      id: '/readings'
      path: '/readings'
      fullPath: '/readings'
      preLoaderRoute: typeof ReadingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/readings/': {
      id: '/readings/'
      path: '/'
      fullPath: '/readings/'
      preLoaderRoute: typeof ReadingsIndexRouteImport
      parentRoute: typeof ReadingsRoute
    }
    '/readings/stats': {
      id: '/readings/stats'
      path: '/stats'
      fullPath: '/readings/stats'
      preLoaderRoute: typeof ReadingsStatsRouteImport
      parentRoute: typeof ReadingsRoute
    }
    '/readings/history': {
      id: '/readings/history'
      path: '/history'
      fullPath: '/readings/history'
      preLoaderRoute: typeof ReadingsHistoryRouteImport
      parentRoute: typeof ReadingsRoute
    }
    '/readings/$id': {
      id: '/readings/$id'
      path: '/$id'
      fullPath: '/readings/$id'
      preLoaderRoute: typeof ReadingsIdRouteImport
      parentRoute: typeof ReadingsRoute
    }
    '/interpretations/new': {
      id: '/interpretations/new'
      path: '/interpretations/new'
      fullPath: '/interpretations/new'
      preLoaderRoute: typeof InterpretationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ReadingsRouteChildren {
  ReadingsIdRoute: typeof ReadingsIdRoute
  ReadingsHistoryRoute: typeof ReadingsHistoryRoute
  ReadingsStatsRoute: typeof ReadingsStatsRoute
  ReadingsIndexRoute: typeof ReadingsIndexRoute
}

const ReadingsRouteChildren: ReadingsRouteChildren = {
  ReadingsIdRoute: ReadingsIdRoute,
  ReadingsHistoryRoute: ReadingsHistoryRoute,
  ReadingsStatsRoute: ReadingsStatsRoute,
  ReadingsIndexRoute: ReadingsIndexRoute,
}

const ReadingsRouteWithChildren = ReadingsRoute._addFileChildren(
  ReadingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ProfileRoute: ProfileRoute,
  ReadingsRoute: ReadingsRouteWithChildren,
  SignupRoute: SignupRoute,
  InterpretationsNewRoute: InterpretationsNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
